import { DiscussionCommentsAndFilesEndPointLogic } from "../../../logic/GeneralDiscussion/DiscussionCommentsAndFilesEndPointLogic";
import { DiscussionLogic } from "./types";

export const generalHandlers: DiscussionLogic = {
  // Fetch comments for a specific discussion object
  fetchComments: (token, object_type, sharedUid, setComments, last_time?) =>
    DiscussionCommentsAndFilesEndPointLogic.getListOfComments(
      token,
      object_type,
      sharedUid,
      setComments,
      last_time
    ),

  // Add a new comment to a specific discussion object
  postComment: async (token, commentBody, sharedUid) => {
    const response =
      await DiscussionCommentsAndFilesEndPointLogic.addNewComment(
        token,
        commentBody,
        sharedUid
      );

    return response;
  },

  // Update an existing comment
  updateComment: async (token, sharedUid, commentBody) => {
    const response =
      await DiscussionCommentsAndFilesEndPointLogic.updateSingleComment(
        token,
        commentBody,
        sharedUid
      );
    return response;
  },

  // Delete a specific comment
  deleteComment: async (token, sharedUid, commentId) => {
    const response =
      await DiscussionCommentsAndFilesEndPointLogic.deleteSingleComment(
        token,
        sharedUid,
        commentId
      );
    return response;
  },

  // Fetch files associated with a specific discussion object
  fetchFiles: (token, object_type, sharedUid, setfiles) =>
    DiscussionCommentsAndFilesEndPointLogic.getListOfFiles(
      token,
      object_type,
      sharedUid,
      setfiles
    ),
  // Upload a new file to a specific discussion object
  uploadFiles: (token, fileUploadBody, sharedUid) =>
    DiscussionCommentsAndFilesEndPointLogic.addNewFile(
      token,
      fileUploadBody,
      sharedUid
    ),
  // Delete a specific file
  deleteFile: async (token, fileId) => {
    const deleteFileResponse =
      await DiscussionCommentsAndFilesEndPointLogic.deleteSingleFile(
        token,
        fileId
      );
    return deleteFileResponse;
  },
};
